<template>
  <div class="skutit-page">
    <!-- Header -->
    <div class="st-header">
      <div>
        <span class="header-eyebrow">Taller</span>
        <h2 class="header-title">SKU Titulos</h2>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ articulos.length }}</span>
        <span class="kpi-foot">SKUs</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Mostrando</span>
        <span class="kpi-value">{{ articulosBusqueda.length }}</span>
        <span class="kpi-foot">resultados</span>
      </div>
    </div>

    <!-- Table -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado</h3>
        <div class="search-box">
          <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
          <input type="text" class="search-box__input" placeholder="Buscar SKU o titulo..." v-model="buscar" />
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="articulosBusqueda"
          :fields="columnasSku"
          class="mb-0"
          hover
          sort-icon-left
          responsive
          show-empty
          empty-text="Sin resultados"
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #cell(skuSingle)="data">
            <span class="cell-sku">{{ data.item.skuSingle }}</span>
          </template>

          <template #cell(titulo)="data">
            <input
              class="titulo-input"
              placeholder="Titulo del producto..."
              v-model="data.item.productTitle"
              v-on:keyup.enter="guardarTitulo(data.item)"
            />
          </template>

          <template #cell(acciones)="data">
            <button class="btn-save" @click="guardarTitulo(data.item)" title="Guardar">
              <i class="fa-solid fa-floppy-disk"></i>
            </button>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ articulosBusqueda.length }} SKUs</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import { BTable, BFormInput, BFormGroup, BRow, BCol } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'

export default {
  components: { BCardCode, BTable, BFormInput, BFormGroup, BRow, BCol, vSelect },
  data() {
    return {
      columnasSku: [
        { key: "skuSingle", label: "SKU", sortable: true },
        { key: "titulo", label: "Titulo", sortable: true },
        { key: "acciones", label: "", thStyle: { width: "60px" } },
      ],
      articulos: [],
      articulosBusqueda: [],
      buscar: "",
    }
  },
  methods: {
    loadItems() {
      axios.post("/uso", { seccion: "skuTitulo" });
      axios.get("/sku/title").then(r => r.data).then(res => {
        this.articulos = res;
        this.articulosBusqueda = res;
      });
    },
    guardarTitulo(data) {
      axios.post("/sku/title", { titulo: data.productTitle, sku: data.skuSingle }).then(r => r.data).then(res => {
        this.$swal({
          icon: 'success',
          title: data.productTitle,
          text: 'El titulo del SKU (' + data.skuSingle + ') se ha actualizado.',
          customClass: { confirmButton: 'btn btn-success' },
        })
      });
    },
  },
  mounted() { this.loadItems(); },
  watch: {
    buscar() {
      this.articulosBusqueda = this.articulos.filter(item => {
        const buscarLower = this.buscar.toLowerCase();
        return item.skuSingle.toLowerCase().includes(buscarLower) || item.productTitle.toLowerCase().includes(buscarLower);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.skutit-page { max-width: 1000px; margin: 0 auto; padding: 0 8px; }

.st-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: $primary; margin-bottom: 2px; }
.header-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 700; color: $text; margin: 0; }

// KPI
.kpi-strip { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 20px; max-width: 400px; }
.kpi-card { background: $card-bg; border: 1px solid $border; border-radius: $radius-sm; padding: 16px 18px; display: flex; flex-direction: column; box-shadow: $shadow; }
.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: "tnum"; margin: 4px 0 2px; }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $text-muted; }

// List card
.list-card {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden;
  &__header { display: flex; justify-content: space-between; align-items: center; padding: 18px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0; }
  &__footer { padding: 12px 22px; border-top: 1px solid $border; }
}

.search-box {
  position: relative; width: 260px;
  &__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: $text-muted; font-size: 12px; }
  &__input { width: 100%; padding: 7px 12px 7px 32px; border: 1px solid $border; border-radius: $radius-sm; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: $text; background: transparent; &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; } }
}

// Table
.table-wrapper { padding: 0; }

// Los ::v-deep van bajo .skutit-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.skutit-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase;
  color: $text-muted; border-top: none; border-bottom: 1px solid $border; padding: 10px 16px; background: transparent;
}

.skutit-page ::v-deep .table-row td {
  padding: 8px 16px; vertical-align: middle; border-color: lighten($border, 3%); font-size: 13px;
}

.skutit-page ::v-deep .table-row:hover td { background: $bg; }

.cell-sku {
  font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 600; color: $primary;
}

.titulo-input {
  width: 100%; padding: 6px 12px; border: 1px solid $border; border-radius: $radius-sm;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: $text; background: transparent;
  transition: border-color 0.15s, box-shadow 0.15s;
  &::placeholder { color: #CBD5E1; }
  &:focus { outline: none; border-color: $primary; box-shadow: 0 0 0 3px rgba($primary, 0.1); }
}

.btn-save {
  width: 34px; height: 34px; border-radius: 8px; border: none; background: rgba($success, 0.1); color: $success;
  cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; transition: all 0.15s;
  &:hover { background: $success; color: white; transform: scale(1.05); }
}

.footer-count { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text-muted; }

// Responsive
@media (max-width: 768px) {
  .list-card__header { flex-direction: column; gap: 10px; align-items: flex-start; }
  .search-box { width: 100%; }
}
</style>

<style lang="scss">
// Dark mode
.dark-layout {
  .skutit-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .search-box__input { border-color: #334155; color: #E2E8F0; &::placeholder { color: #475569; } &:focus { border-color: #3B82F6; } }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }

    .cell-sku { color: #60A5FA; }
    .titulo-input { border-color: #334155; color: #E2E8F0; background: #0F172A; &:focus { border-color: #3B82F6; } }
    .btn-save { background: rgba(#10B981, 0.15); &:hover { background: #10B981; } }
  }
}
</style>
